class IntervaloNumeracaoReportModal {
    static get $inject() {
        return ['$scope', 'gql', 'downloadService']
    }

    constructor($scope, gql, downloadService) {
        this.apply = fn => $scope.$apply(fn)
        this.gql = gql
        this.downloadService = downloadService

        this.reportOptions = {
            format: 'XLSX',
            selected: []
        }
    }

    $onInit() {
        this.serie = this.resolve.serie

        this.promise = this
            .loadFields()
            .then(fields => this.fields = fields)
            .finally(() => this.apply())
    }

    loadFields() {
        const query = gql`
            query IntervaloNumeracaoReportFields {
                reportFields {
                    fields: intervaloNumeracao {
                        name
                        description
                    }
                }
            }
        `

        return this.gql
            .query(query)
            .then(({ reportFields: { fields } }) => fields)
    }

    gerarRelatorio() {
        const query = gql`
            query IntervaloNumeracaoReport($filialId: Int!, $filter: IntervaloNumeracaoFilter, $fields: [IntervaloNumeracaoReportFieldName!], $format: ReportFormat!) {
                filial(id: $filialId) {
                    id
                  operation: intervaloNumeracaoReport(filter: $filter, format: $format, fields: $fields) {
                    token
                    next
                  }
                }
            }
        `

        const { order, ...rest } = this.resolve.filter

        let filter = Object.assign(rest, { serie: this.resolve.serie })

        if (filter.periodoIncludes) {
            let from = this.formatDate(filter.periodoIncludes.from)
            let to = this.formatDate(filter.periodoIncludes.to)

            filter.periodoIncludes = { from: from, to: to }
        }

        delete filter.filial

        const selected = ["SERIE", "MODELO", "INTERVALO", "PERIODO"]

        this.downloadPromise = this.downloadService
            .resumeOperation(next => {
                const variables = {
                    fields: selected,
                    filialId: parseInt(this.resolve.filial.id),
                    filter: filter,
                    format: this.reportOptions.format,
                    order: order,
                    next: next
                }

                return this.gql
                    .query(query, variables)
                    .then(({ filial: { operation } }) => operation)
            })
            .finally(() => this.apply())
    }

    formatDate(date) {
        if (date) {
            let day = date.getDate().toString().padLeft(2, '0')
            let month = (date.getMonth() + 1).toString().padLeft(2, '0')
            let year = date.getFullYear()

            return `${year}-${month}-${day}`
        } else {
            return null
        }
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('intervaloNumeracaoReportModal', {
        controller: IntervaloNumeracaoReportModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal modal-title="Exportação de intervalos de numerações ausentes" close="$ctrl.close">
            <modal-body>                                
                <highlighted>
                    <main>Exportação de intervalos de numerações ausentes</main>
                    <secondary>Selecione abaixo o formato do arquivo e os campos que serão exportados.</secondary>
                </highlighted>                

                <div>
                    <div class="smart-form">
                        <div class="inline-group">
                            <label class="radio no-break">
                                <input type="radio" ng-model="$ctrl.resolve.serie" ng-value="undefined">
                                <i></i> Relatório de todas as séries
                            </label>
                            <label class="radio no-break">
                                <input type="radio" ng-model="$ctrl.resolve.serie" ng-value="$ctrl.serie">
                                <i></i> Relatório da série <b>{{$ctrl.serie}}</b>
                            </label>
                        </div>
                    </div>
                    <br>
                </div>
            </modal-body>

            <modal-footer>
                <promise-tracker promise="$ctrl.downloadPromise" active="$ctrl.isLoading">
                    <button class="btn btn-primary" disabled ng-show="$ctrl.isLoading">
                        <i class="fa fa-circle-o-notch fa-spin"></i> Exportando...
                    </button>
                    <button class="btn btn-primary" ng-click="$ctrl.gerarRelatorio()" ng-hide="$ctrl.isLoading">Exportar</button>
                    <button class="btn btn-default" ng-click="$ctrl.close()" ng-disabled="$ctrl.isLoading">Fechar</button>
                </promise-tracker>
            </modal-footer>
        </modal>
        `
    })
